<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <Breadcrumbs
        headline="Hiển thị & Phân quyền"
        :link="[{ text: 'Hiển thị & Phân quyền', href: '../department' }]"
      />
    </div>

    <v-card class="pa-2 mx-md-2">
      <v-tabs color="amber darken-1" :right="$vuetify.breakpoint.mobile">
        <v-tab> Hiển Thị </v-tab>
        <v-tab> Thiết Lập Quyền </v-tab>
        <!-- <v-tab> Cài Đặt </v-tab> -->

        <v-tab-item>
          <infor-tabs-item
            :department="department"
            @save="save"
          ></infor-tabs-item>
        </v-tab-item>
        <v-tab-item>
          <policy-tabs-item
            :department="department"
            :roles="roles"
            @save="save"
          ></policy-tabs-item>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import InforTabsItem from '@/modules/department/InforTabsItem'
import PolicyTabsItem from '@/modules/department/PolicyTabsItem'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'

export default {
  components: {
    InforTabsItem,
    PolicyTabsItem,
    Breadcrumbs
  },
  data() {
    return {
      search: '',
      tab: null,
      headers: [
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'title',
        },
        { text: 'description', value: 'description' },
        { text: 'price(vnd)', value: 'price' },
      ],
    }
  },
  computed: {
    ...mapGetters('department', ['departments', 'department']),
    ...mapGetters('app', ['roles']),
  },
  methods: {
    ...mapActions('department', ['fetchDepartment', 'updateDepartment']),
    save(department) {
      this.updateDepartment({ ...this.department, ...department })
    },
  },
  async created() {
    this.fetchDepartment(this.$route.params.id)
  },
}
</script>
<style lang='scss' scoped>
::v-deep {
  .v-tab--active {
    background-color: #ffecb3;
    color: #212121;
  }
}
</style>
